var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',{scopedSlots:_vm._u([{key:"links",fn:function(props){return [_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          icon: 'ni ni-shop text-primary',
          path: '/alternative'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Users',
          icon: 'ni ni-ungroup text-orange'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Add User',
            icon: 'ni ni-circle-08 text-red',
            path: '/users/add'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'User List',
            icon: 'ni ni-circle-08 text-red',
            path: '/users/list'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Branch Assignment',
            icon: 'ni ni-building text-teal',
            path: '/users/branch-assignment'
          }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Vendors',
          icon: 'ni ni-circle-08 text-blue'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Add Vendor',
            icon: 'ni ni-circle-08 text-red',
            path: '/vendors/add'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Vendors',
            icon: 'ni ni-circle-08 text-green',
            path: '/vendors/list'
          }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Attendance',
          icon: 'ni ni-calendar-grid-58 text-blue',
          path: '/attendance'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Branches',
          icon: 'ni ni-building text-teal',
          path: '/branches'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Branch Transfers',
          icon: 'ni ni-delivery-fast text-orange',
          path: '/branch-transfers'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Branch Inventory',
          icon: 'ni ni-archive-2 text-yellow',
          path: '/branch-inventory'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Stock Movements',
          icon: 'ni ni-chart-bar-32 text-blue',
          path: '/stock-movements'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Vouchers',
          icon: 'ni ni-collection text-green',
          path: '/vouchers/list'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Payments',
          icon: 'ni ni-circle-08 text-green'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Accept Payment',
            icon: 'ni ni-circle-08 text-red',
            path: '/accept/payments'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Transactions List',
            icon: 'ni ni-circle-08 text-green',
            path: '/transactions/list'
          }}})],1)]}}])},[_c('template',{slot:"links-after"},[_c('hr',{staticClass:"my-3"}),_c('h6',{staticClass:"p-0 navbar-heading text-muted"},[_vm._v("Sale")]),_c('ul',{staticClass:"navbar-nav mb-md-3"},[_c('sidebar-item',{attrs:{"link":{
            name: 'POS',
            icon: 'ni ni-cart text-red',
            path: '/pos'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Products',
            icon: 'ni ni-basket text-info'
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: 'Add Product',
              icon: 'ni ni-circle-08 text-red',
              path: '/products/add'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Product List',
              icon: 'ni ni-circle-08 text-red',
              path: '/products/list'
            }}})],1),_c('sidebar-item',{attrs:{"link":{
            name: 'Sale List',
            icon: 'ni ni-bullet-list-67 text-green',
            path: '/sales/list'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Sale Quotations',
            icon: 'ni ni-bullet-list-67 text-yellow',
            path: '/sales/quotations'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Credit Notes',
            icon: 'ni ni-bullet-list-67 text-primary',
            path: '/creditNote/list'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Customer Chalans',
            icon: 'ni ni-bullet-list-67 text-pink',
            path: '/customer-chalans'
          }}})],1)]),_c('template',{slot:"links-after"},[_c('hr',{staticClass:"my-3"}),_c('h6',{staticClass:"p-0 navbar-heading text-muted"},[_vm._v("Purchase")]),_c('ul',{staticClass:"navbar-nav mb-md-3"},[_c('sidebar-item',{attrs:{"link":{
            name: 'Add Purchase',
            icon: 'ni ni-bullet-list-67 text-green',
            path: '/purchases/add'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Purchase List',
            icon: 'ni ni-bullet-list-67 text-green',
            path: '/purchases/list'
          }}})],1)]),_c('template',{slot:"links-after"},[_c('hr',{staticClass:"my-3"}),_c('h6',{staticClass:"p-0 navbar-heading text-muted"},[_vm._v("Service")]),_c('ul',{staticClass:"navbar-nav mb-md-3"},[_c('sidebar-item',{attrs:{"link":{
            name: 'Service Requests',
            icon: 'ni ni-badge text-orange',
            path: '/serviceRequests/list'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Chalans List',
            icon: 'ni ni-bullet-list-67 text-blue',
            path: '/chalans/list'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Quotation List',
            icon: 'ni ni-bullet-list-67 text-green',
            path: '/quotations/list'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Messages',
            icon: 'ni ni-email-83 text-yellow',
            path: '/messages/list'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Bill Requests',
            icon: 'ni ni-bullet-list-67 text-purple',
            path: '/billRequests/list'
          }}})],1)]),_c('template',{slot:"links-after"},[_c('hr',{staticClass:"my-3"}),_c('h6',{staticClass:"p-0 navbar-heading text-muted"},[_vm._v("Masters")]),_c('ul',{staticClass:"navbar-nav mb-md-3"},[_c('sidebar-item',{attrs:{"link":{
            name: 'Service Master',
            icon: 'ni ni-circle-08 text-blue'
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: 'Service Categories',
              icon: 'ni ni-bullet-list-67 text-red',
              path: '/serviceCategories/list'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Services',
              icon: 'ni ni-html5',
              path: '/services/list'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Service Jobs',
              icon: 'ni ni-bullet-list-67 text-yellow',
              path: '/service/jobs/list'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Jobs',
              icon: 'ni ni-bullet-list-67 text-green',
              path: '/jobs/list'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Labor Cost',
              icon: 'ni ni-bullet-list-67 text-green',
              path: '/labor/costs/list'
            }}})],1),_c('sidebar-item',{attrs:{"link":{
            name: 'General Settings',
            icon: 'ni ni-settings-gear-65 text-red'
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: 'Expense Types',
              path: '/expenses/type/list',
              icon: 'ni ni-bullet-list-67'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Product Units',
              icon: 'ni ni-bullet-list-67 text-red',
              path: '/product-units/list'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Payment Modes',
              icon: 'ni ni-money-coins text-green',
              path: '/payment-modes/list'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Taxes',
              icon: 'ni ni-bullet-list-67 text-blue',
              path: '/taxes/list'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Roles',
              icon: 'ni ni-bullet-list-67 text-blue',
              path: '/roles/list'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Attributes',
              icon: 'ni ni-bullet-list-67 text-yellow',
              path: '/attributes/list'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Statuses',
              icon: 'ni ni-bullet-list-67 text-red',
              path: '/statuses/list'
            }}})],1),_c('sidebar-item',{attrs:{"link":{
            name: 'Suppliers',
            icon: 'ni ni-delivery-fast text-info',
            path: '/suppliers/list'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Expenses',
            icon: 'ni ni-money-coins text-orange',
            path: '/expenses/list'
          }}})],1)])],2),_c('div',{staticClass:"main-content"},[(!_vm.$route.meta.hideNavbar)?_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}):_vm._e(),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }